import React, { Component } from 'react';
import { ArrowUpOutlined } from "@ant-design/icons";

export default class Scrolltop extends Component {
    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    render() {
        return (
            <div
                id="kt_scrolltop"
                className="kt-scrolltop"
                onClick={this.scrollToTop}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <ArrowUpOutlined style={{ color: '#ffffff', fontSize: '1.2rem' }} />
            </div>
        )
    }
}